export default "__VITE_ASSET__CfANRCDB__"